import styled from 'styled-components';

export const Container = styled.div`
    .notes-header {
        font-size: 1rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;